<script>
    export default {
        
    }
</script>

<template>
    <div class="card">
        <div class="card-image">
            <picture class="image"><img width="400" height="300" alt="Placeholder image" /></picture>
        </div>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column">
            <div v-for="index in 3" :key="index" class="block">
                <div class="block"><div class="progress is-large" value="0" max="100"></div></div>
            </div>
        </div>
    </div>
</template>
